let isDev = (location.href.startsWith("http://localhost"))  // 调试模式或生产模式
const dumyLogin = isDev && false // 提供一个假token

const cfg = {
  install(Vue) {
    Vue.prototype.$cfg = this
  },
  sys: {
    code: 'registration',
    name: '门诊挂号收费',
    version: '1.5.1',
    copyright: 'Copyright © 2022 by 北京数字医信科技有限公司',
    icp: '京ICP备18034820号',
  },
  isDev: isDev ,
  oauth: (() => {
    if (isDev) {
      return {
        server: 'http://10.10.203.135:8200',
        client: 'registration',
        callbackUrl: 'http://localhost:8080/callback'
      }
    } else {
      return {
        server: 'https://authdev.51trust.net',
        client: 'registration',
        callbackUrl: 'https://registrationdev.51trust.net/callback'
      }
    }
  })(),
  token: (() => {
    if (dumyLogin) {
      return 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mbyI6eyJwYXNzd29yZCI6bnVsbCwidXNlcm5hbWUiOiJhZG1pbiIsImF1dGhvcml0aWVzIjpbXSwiYWNjb3VudE5vbkV4cGlyZWQiOnRydWUsImFjY291bnROb25Mb2NrZWQiOnRydWUsImNyZWRlbnRpYWxzTm9uRXhwaXJlZCI6dHJ1ZSwiZW5hYmxlZCI6dHJ1ZSwiaWQiOjIsInJlYWxOYW1lIjoi6LaF57qn566h55CG5ZGYIiwidGVuYW50SWQiOiIwIiwidGVuYW50Q29kZSI6Inp6IiwidGVuYW50TmFtZSI6Iuenn-S4uyIsImRlcHRDb2RlIjoiY3MxIiwiZGVwdE5hbWUiOiLmtYvor5UxIiwiZGVwdENvZGVzIjoiW1wiY3MxXCIsXCJjczJcIl0iLCJwb3NpdGlvbiI6bnVsbH0sImF1ZCI6WyJ1c2VyIl0sInVzZXJfbmFtZSI6ImFkbWluIiwic2NvcGUiOlsicmVhZF9wcm9maWxlIl0sImV4cCI6MTU5OTU2MzEzNSwianRpIjoiYzRjMDE3N2MtMWMyZi00NzdiLWE0MzktNDUxYTFhYmQzYWM5IiwiYXV0aG9yaXRpZXMiOltdLCJjbGllbnRfaWQiOiJtYXN0ZXJkYXRhIn0.uhbf6ZudcnxFiwg_Z_0zX2CqQrh4LJNJCrnexqqLKSyVZqrkPEwcuf09w5UlWkq2KL-KV0Ir8nJpnwRoMRr-brQLzyOg_SthzMMqibNUALy_cbMPMuofiT4uX3OCpSVpwvhWr93VZMTQzwx6b4FwwHPGs_XqQpDmKKkP81o8PEBbarHY1pb7g1ynDAY2MI962Tk3E5ecRPYNhzccOo9_YFpTx6M_hli9qzLbbI9aiknTFIVbOd-FsNq13US5skggjJExrkl-WRqo6bTWvh55jGYY8o1JDTY_Df5kAzk590D2GQSeBsya49Y--gsTzG0IBrAcsVFRHWUMe8Qm3bF6qg'
    } else {
      return null
    }
  })(),
  socket: (() => {
    return {
      server: 'ws://10.10.203.203:8100'
    }
  })(),
  idCard:{
    url:() => {
      return "http://127.0.0.1:19196/readcard&t=" + Math.random()
    },
    //华视电子
    type:'huashi'
  },
  medCard:{
    url:() => {
      return "http://127.0.0.1:10089/medapi/read"
    },
  },
  jimureport: (() => {
    return {
      server: 'https://jimureport.jiicm.com'
    }
  })(),
  errs: {
    Nomal: { code: 400, msg: '不好，出错了！' },
    NeedLogin: { code: 402, msg: '不好意思，您需要登录以后才能继续访问！' },
    OverdueToken: { code: 405, msg: '抱歉，由于长时间未操作，登录已超时！' },
    NeedPromission: { code: 406, msg: "抱歉，缺少访问权限，请联系管理员为您授权！" },
    NoAuthority: { code: 401, msg: '由于缺少权限，调用后台接口失败！' },
    NoPath: { code: 404, msg: '抱歉，要访问的页面不存在！' },
    Refusal: { code: 407, msg: "抱歉，由于您拒绝了授权，因此无法使用本系统！" }
  }
}
